import { getDateInFormat } from "@domains/utils/reportDates";
import { EApplicationStatus, } from "../entities/aopOrderBookEntity";
import { EGenericStatusType } from "@frameworks/shared-library/components/GenericStatus/GenericStatus";
import { toCamelCase } from "@domains/utils/stringMethods";
export var aopOrderbookMapper = function (data) {
    var _a, _b;
    var aopOrderbookEntity = {
        orderBookList: [],
        totalRecord: 0,
    };
    if (data && (data === null || data === void 0 ? void 0 : data.length) > 0) {
        aopOrderbookEntity.totalRecord = ((_a = data[0]) === null || _a === void 0 ? void 0 : _a.TotalRecords)
            ? data[0].TotalRecords
            : (_b = data[0]) === null || _b === void 0 ? void 0 : _b.totalRecords;
        data.map(function (code) {
            var orderbookEntity = {
                clientName: (code === null || code === void 0 ? void 0 : code.clientName) === " "
                    ? "-"
                    : displayDash((code === null || code === void 0 ? void 0 : code.ClientName)
                        ? toCamelCase(code === null || code === void 0 ? void 0 : code.ClientName)
                        : toCamelCase(code === null || code === void 0 ? void 0 : code.clientName)),
                accountCode: displayDash((code === null || code === void 0 ? void 0 : code.ApplicationId) ? code === null || code === void 0 ? void 0 : code.ApplicationId : code === null || code === void 0 ? void 0 : code.applicationId),
                leadId: displayDash((code === null || code === void 0 ? void 0 : code.LeadId) ? code === null || code === void 0 ? void 0 : code.LeadId : code === null || code === void 0 ? void 0 : code.leadId),
                clientEntity: displayDash((code === null || code === void 0 ? void 0 : code.Entity) ? code === null || code === void 0 ? void 0 : code.Entity : code === null || code === void 0 ? void 0 : code.entity),
                kycStatus: displayDash((code === null || code === void 0 ? void 0 : code.KycStatus) ? code === null || code === void 0 ? void 0 : code.KycStatus : code === null || code === void 0 ? void 0 : code.kycStatus),
                dateTime: displayDash((code === null || code === void 0 ? void 0 : code.CreatedDate) ? code === null || code === void 0 ? void 0 : code.CreatedDate : code === null || code === void 0 ? void 0 : code.createdDate) !== "-"
                    ? getDateInFormat((code === null || code === void 0 ? void 0 : code.CreatedDate) ? code === null || code === void 0 ? void 0 : code.CreatedDate : code === null || code === void 0 ? void 0 : code.createdDate, "DD MMM YY hh:mm:ss A")
                    : "-",
                displayStatus: (code === null || code === void 0 ? void 0 : code.applicationStatus) == "Ibeats Success" ||
                    (code === null || code === void 0 ? void 0 : code.ApplicationStatus) == "Ibeats Success"
                    ? "Account Opened Successfully"
                    : displayDash((code === null || code === void 0 ? void 0 : code.ApplicationStatus)
                        ? code === null || code === void 0 ? void 0 : code.ApplicationStatus
                        : code === null || code === void 0 ? void 0 : code.applicationStatus),
                status: (!!(code === null || code === void 0 ? void 0 : code.applicationStatus) && (code === null || code === void 0 ? void 0 : code.applicationStatus) !== "") ||
                    (!!(code === null || code === void 0 ? void 0 : code.ApplicationStatus) && (code === null || code === void 0 ? void 0 : code.ApplicationStatus) !== "")
                    ? getStatus((code === null || code === void 0 ? void 0 : code.ApplicationStatus)
                        ? code === null || code === void 0 ? void 0 : code.ApplicationStatus
                        : code === null || code === void 0 ? void 0 : code.applicationStatus)
                    : "-",
                statusDate: getDateInFormat((code === null || code === void 0 ? void 0 : code.StatusDate) ? code === null || code === void 0 ? void 0 : code.StatusDate : code === null || code === void 0 ? void 0 : code.statusDate, "DD MMM YY, hh:mm:ss A"),
                authLinkBtn: (code === null || code === void 0 ? void 0 : code.AuthLinkBtn) ? code === null || code === void 0 ? void 0 : code.AuthLinkBtn : code === null || code === void 0 ? void 0 : code.authLinkBtn,
                selfieLinkBtn: (code === null || code === void 0 ? void 0 : code.SelfieLinkBtn)
                    ? code === null || code === void 0 ? void 0 : code.SelfieLinkBtn
                    : code === null || code === void 0 ? void 0 : code.selfieLinkBtn,
            };
            aopOrderbookEntity.orderBookList.push(orderbookEntity);
        });
    }
    return aopOrderbookEntity;
};
var displayDash = function (orderBook) {
    var value = "-";
    if (typeof orderBook == "string" && !!orderBook && orderBook !== "")
        value = orderBook;
    if (typeof orderBook == "number" && !!orderBook && orderBook !== 0) {
        value = orderBook;
    }
    return value;
};
var getStatus = function (applicationStatus) {
    var status = "-";
    switch (applicationStatus) {
        case EApplicationStatus.QC_PENDING:
            status = EGenericStatusType.WARNING;
            break;
        case EApplicationStatus.QC_APPROVED:
            status = EGenericStatusType.SUCCESS;
            break;
        case EApplicationStatus.QC_REJECTED:
            status = EGenericStatusType.DANGER;
            break;
        case EApplicationStatus.IBEASTS_FAILED:
            status = EGenericStatusType.DANGER;
            break;
        case EApplicationStatus.IBEASTS_SUCCESS:
            status = EGenericStatusType.SUCCESS;
            break;
        case EApplicationStatus.ACTIVE_FOR_TRADE:
            status = EGenericStatusType.SUCCESS;
            break;
        case EApplicationStatus.ACTIVE_FOR_TRADE_FAILED:
            status = EGenericStatusType.DANGER;
            break;
        default:
            status = EGenericStatusType.WARNING;
            break;
    }
    return status;
};
